import React from 'react'
import styled from '@emotion/styled'

import Spinner from '../../generic/spinner'
import BasicButton from '../../generic/button'
import { breakpoints } from '../../../constants'
import { fontSizeXSmall, fontSizeSmall, white } from '../../../constants/principles'
import { Button } from '@argo/ui-elements'
import { ThemeProvider } from '@emotion/react'
import { kbbTheme } from '@argo/themes'

export default ({ isLoading, onClick, argo }) => {
  const commonProps = {
    'data-testid': 'bi-btn-go',
    disabled: isLoading,
    onClick: e => onClick(e)
  }
  const buttonLabel = isLoading ? <Spinner absolute={false} /> : 'Go'

  return argo ? (
    <ThemeProvider theme={kbbTheme}>
      <ArgoButton {...commonProps} text={buttonLabel} buttonType={'primary'} enableCapitalize={false} />
    </ThemeProvider>
  ) : (
    <StyledButton {...commonProps} secondary={isLoading}>
      {buttonLabel}
    </StyledButton>
  )
}

const ArgoButton = styled(Button)`
  width: 60px;
  > span {
    min-height: 42px !important;
    width: 50px;
    @media (min-width: ${breakpoints.lg}px) {
      width: 75px;
      margin-right: -15px;
    }
  }
`

const StyledButton = styled(BasicButton)`
  padding: 0px 14px;
  margin: 0;
  font-size: ${p => (p.isSelected ? fontSizeSmall : fontSizeXSmall)};
  line-height: 26px;
  border-radius: 6px;
  &:disabled {
    background-color: ${white};
  }
  display: flex;
  align-items: center;

  @media (min-width: ${breakpoints.sm}px) {
    margin-left: 8px;
  }
`
